<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-2 p-pb-1">
      <div class="p-grid p-ai-center vertical-container">
          <div class="p-col-fixed" style="width:55px;">
              <a @click="$functions.historyBack()" style="cursor: pointer">
                <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
              </a>
          </div>
          <div class="p-col">
              <h3>{{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}}</h3>
          </div>
      </div>
        
        <div class="irinox-form" >

          <div class="p-grid nested-grid appliance-details">
            <div class="p-col-12" style="max-width:580px">
              <div class="p-grid p-ai-center">
                <div class="p-col-5 p-d-flex p-ai-center p-jc-end" style="max-width: 240px; height: 380px;">
                  <div style="position: relative;">
                      <div class="details-plan-badges">
                        <div v-if="hasPlanActive('PLUS')" class="plan-badge">
                          <div class="plan-plus">
                            <img src="/assets/irinox/icons/plans/plus.svg" :alt="$t('admin.plans.table_badge_active_plus')" />
                          </div>
                        </div>
                        <div v-if="hasPlanActive('PREMIUM')" class="plan-badge">
                          <div class="plan-premium">
                            <img src="/assets/irinox/icons/plans/premium.svg" :alt="$t('admin.plans.table_badge_active_premium')" />
                          </div>
                        </div>
                        <div v-if="hasPlanActive('GELATERIA')" class="plan-badge">
                          <div class="plan-gelateria">
                            <img src="/assets/irinox/icons/plans/gelateria.svg" :alt="$t('admin.plans.table_badge_active_gelateria')" />
                          </div>
                        </div>
                      </div>
                      <img :src="$images.image(appliance.modelNumber, appliance.accessory, true)" style="max-width: 240px; max-height: 330px;" :alt="appliance.modelNumber"/>
                    </div>
                </div>
                <div class="p-col-7 overview">
                  <DetailsOverview :serialNumber="serialNumber" />
                </div>
              </div>
              <div class="p-grid">
                <div class="p-col p-text-center p-p-1">
                  <Button :label="$t('details.buttons.haccp_button')" class="p-button-secondary p-m-2" @click="haccp"/>
                  <Button v-if="(role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('INTERNAL') || role.includes('SERVICE') || appliance.role==='ADMIN') && appliance.gamma!='EF Next'" :label="$t('details.buttons.analytics_button')" class="p-button-secondary p-m-2" @click="analytics"/>
                  <Button v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MF Next' && !role.includes('INTERNAL')" :disabled="!appliance.cycleLibrary" :label="$t('details.buttons.cycle_library_button')" class="p-button-secondary p-m-2" @click="library"/>
                  <Button v-if="appliance.energy" :label="$t('details.buttons.energy_button')" class="p-button-secondary p-m-2" @click="energyPanel"/>
                  <MYACycleButton v-if="appliance.gamma=='MYA' && appliance.disableCycleRunning === false && !role.includes('INTERNAL')" :serialNumber="serialNumber" />
                  <Button v-if="$config.afterSalesEnabled()" :label="$t('details.buttons.documents')" class="p-button-secondary p-m-2" @click="documents"/>
                  <Button v-if="$config.isFreviEnabled(appliance)" :label="'FRESH VISION'" class="p-button-secondary p-m-2" @click="freshVision"/>
                </div>
              </div>
            </div>
            <div class="p-col">
              <div class="anomaly-advise" v-if="isAnomalyActive && $config.maintenanceEnabled()">
                <div class="anomaly-advise-close" @click="closeAnomaly()" v-if="role==='USER'">
                  <i class="pi pi-times" />
                </div>
                <div class="p-grid p-nogutter p-pt-4 p-pb-4">
                  <div class="p-col-fixed p-d-flex p-jc-center" style="width: 60px;">
                    <img src="assets/irinox/icons/maintenance.svg" :alt="$t('common.anomaly')" style="width: 24px; height: 24px;"/>
                  </div>
                  <div class="p-col">
                    <p class="anomaly-advise-title">{{$t('details.anomaly_advise_title')}}</p>
                    <p class="anomaly-advise-text" v-html="$t('details.anomaly_advise_text')"></p>
                    <p class="anomaly-advise-note">{{$t('details.anomaly_advise_note')}}</p>
                  </div>
                </div>

              </div>
              <div class="plus-premium-advise" v-if="isPlusPremiumActivable">
                <div class="plus-premium-advise-close" @click="closePlusPremium()">
                  <i class="pi pi-times" />
                </div>
                <div class="p-grid p-nogutter p-pt-4 p-pb-4">
                  <div class="p-col-fixed p-d-flex p-jc-center" style="width: 60px;">
                    <div class="plan-badge">
                      <div class="plan-premium">
                        <img src="/assets/irinox/icons/plans/premium.svg" :alt="$t('admin.plans.table_badge_active_premium')" />
                      </div>
                    </div>
                  </div>
                  <div class="p-col">
                    <p class="plus-premium-advise-title">{{$t('details.plus_premium_advise_title')}}</p>
                    <p class="plus-premium-advise-note" @click="$router.push('/admin?tab=services')">{{$t('details.plus_premium_advise_note')}}</p>
                  </div>
                </div>

              </div>
              <TabView class="irinox-tab">
                <TabPanel>
                  <template #header>
                      <div class="p-d-flex p-ai-center p-ml-3 p-mr-1">
                          <div :class="['icon-status',appliance.online?'icon-green':'icon-gray']" style="font-size: 30px;"/>
                          <div class="p-ml-2" style="line-height: 1;">{{$t('details.tab_parameters')}}</div>
                      </div>
                  </template>
                  <CPParameters v-if="appliance.type=='CONSERVATORE'" :serialNumber="serialNumber" />
                  <MFParameters v-else-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MF Next'" :serialNumber="serialNumber" />
                  <EFParameters v-else-if="appliance.type=='ABBATTITORE' && appliance.gamma=='EF Next'" :serialNumber="serialNumber" />
                  <SFParameters v-else-if="appliance.type=='ABBATTITORE' && appliance.gamma=='SF'" :serialNumber="serialNumber" />
                  <MYAParameters v-else-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MYA'" :serialNumber="serialNumber" />
                  <MP0Parameters v-else-if="appliance.type=='FERMALIEVITA' && mpFunction===0" :serialNumber="serialNumber" />
                  <MP1Parameters v-else-if="appliance.type=='FERMALIEVITA' && mpFunction===1" :serialNumber="serialNumber" />
                </TabPanel>
                <TabPanel v-if="role.includes('SERVICE') || role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('INTERNAL')">
                  <template #header>
                      <div class="p-d-flex p-ai-center p-ml-5 p-mr-1">
                          <!-- <i :class="['pi pi-microchip',appliance.online?'':'gray']" class="" style="font-size: 30px;"/> -->
                          <div :class="['icon-tab_extra',appliance.online?'':'icon-gray']" style="font-size: 32px;"/>
                          <div class="p-ml-2" style="line-height: 1;">{{$t('details.tab_advanced')}}</div>
                      </div>
                  </template>
                  <DetailsExtras :serialNumber="serialNumber" />
                </TabPanel>
                <TabPanel>
                  <template #header>
                      <div class="p-d-flex p-ai-center p-ml-5 p-mr-1">
                          <div :class="['icon-tab_info',appliance.online?'':'icon-gray']" style="font-size: 30px;"/>
                          <div class="p-ml-2" style="line-height: 1;">{{$t('details.tab_info')}}</div>
                      </div>
                  </template>
                  <DetailsInfo :serialNumber="serialNumber" />
                </TabPanel>
                <TabPanel>
                  <template #header>
                      <div class="p-d-flex p-ai-center p-ml-5 p-mr-1">
                          <div :class="['icon-alert',flagAlarm?'icon-red':'icon-gray']" style="font-size: 28px;"/>
                          <div class="p-ml-2" style="line-height: 1;">{{$t('details.tab_alarms')}}</div>
                      </div>
                  </template>
                  <DetailsAlarms :serialNumber="serialNumber" />
                </TabPanel>
                <!-- <TabPanel :header="$t('details.tab_notifications')">
                  <div> NOTIFICHE </div>
                </TabPanel> -->
              </TabView>
            </div>
          </div>

        </div>
		</div>
	</div>

  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />


</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import EventHubListenerService from '../../service/EventHubListenerService';
import DetailsOverview from './DetailsOverview.vue';
import CPParameters from './cp/Parameters.vue';
import MFParameters from './mf/Parameters.vue';
import EFParameters from './ef/Parameters.vue';
import SFParameters from './sf/Parameters.vue';
import MYAParameters from './mya/Parameters.vue';
import MYACycleButton from './mya/CycleButton.vue';
import MP0Parameters from './mp/Parameters_0.vue';
import MP1Parameters from './mp/Parameters_1.vue';
import DetailsExtras from './DetailsExtras.vue';
import DetailsInfo from './DetailsInfo.vue';
import DetailsAlarms from './DetailsAlarms.vue';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
      DetailsOverview,
      CPParameters,
      MFParameters,
      EFParameters,
      SFParameters,
      MYAParameters,
      MYACycleButton,
      MP0Parameters,
      MP1Parameters,
      DetailsExtras,
      DetailsInfo,
      DetailsAlarms,
      IrinoxDialogDark
    },
    data() {
        return {
          serialNumber: this.$route.params.serialNumber,
          dialog: {
            blockingError: false,
            error: false,
          },
          infoBox: {
            closePlusPremiumAdvise: false,
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        flagAlarm: function() {
            if(this.appliance.alarms!=null) {
              for(let i=0; i<this.appliance.alarms.length; i++) {
                if(this.appliance.alarms[i].active) {
                  return true;
                }
              }
            }
            return false;
        },
        mpFunction: function() {
          if(this.appliance.status && this.appliance.status.function!=null) {
            return this.appliance.status.function;
          }
          if(this.deviceTwin.status && this.deviceTwin.status.function!=null) {
            return this.deviceTwin.status.function;
          }
          return null;
        },
        isAnomalyActive() {
          // //Check if at least one anomaly is active == true
          // return this.appliance.anomalies && this.appliance.anomalies.some(anomaly => anomaly.active === true);
          return this.appliance.anomaliesToRead;
        },
        isPlusPremiumActivable() {
          return this.role==='USER' && (this.hasPlanActivable('PLUS') || this.hasPlanActivable('PREMIUM')) && !this.hasPlanActive('PLUS') && !this.hasPlanActive('PREMIUM') && !this.infoBox.closePlusPremiumAdvise;
        }
    },
    watch: {
    },
    created() {
      this.applianceService = new ApplianceService();
      this.eventHubListenerService = new EventHubListenerService();
      this.$store.commit('appliances/deviceTwin', {});
      this.infoBox.closePlusPremiumAdvise = sessionStorage.getItem(this.serialNumber+'_closePlusPremiumAdvise') === 'true';
    },
    mounted() {
      // if(!this.$config.mock) {
        this.reloadAppliance();
      // }
      this.reloadDeviceTwin();
    },
    methods: {
      reloadAppliance() {
        this.applianceService.getAppliance(this.personaltoken, this.serialNumber)
          .then((data) => {
            if(data.code=="200") {
              let appliance = data.body;
              this.$store.commit('appliances/applianceDetails', appliance);
              if(appliance.online) {
                this.eventHubListenerService.postRunLive(this.personaltoken, this.serialNumber)
                  .then((data) => {
                    if(data.code=="200") {
                      console.log("RUN LIVE success")
                    } else {
                      console.error("RUN LIVE ERROR "+JSON.stringify(data));
                    }
                  })
                  .catch(error => {
                    console.error("RUN LIVE ERROR "+error);
                  });
              }
            } else {
              console.error(JSON.stringify(data));
              this.dialog.blockingError = true;
              setTimeout(function() {
                this.$router.push({ name: 'dashboard' });
              }.bind(this),3000);
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.blockingError = true;
            setTimeout(function() {
              this.$router.push({ name: 'dashboard' });
            }.bind(this),3000);
          });
      },
      reloadDeviceTwin() {
        this.eventHubListenerService.getDeviceTwin(this.personaltoken, this.serialNumber, this.appliance.type)
          .then((data) => {
            if(data.code=="200") {
              let dt = data.body;
              dt.serialNumber = this.serialNumber;
              this.$store.commit('appliances/deviceTwin', dt);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.blockingError = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.blockingError = true;
          });
      },
      haccp() {
        this.$router.push({ name: 'haccp-reports-historyback', params: { serialNumber: this.appliance.serialNumber }});
      },
      analytics() {
        this.$router.push({ name: 'appliance-analytics', params: { serialNumber: this.appliance.serialNumber }});
      },
      library() {
        this.$router.push({ name: 'appliance-library', params: { serialNumber: this.appliance.serialNumber }});
      },
      energyPanel() {
        this.$router.push({ name: 'energy-details-historyback', params: { serialNumber: this.appliance.serialNumber }});
      },
      documents() {
        this.$router.push({ name: 'after-sales-model', params: { modelId: this.appliance.modelId, modelDomain: this.appliance.domain ?? 'STANDARD' }});
      },
      freshVision() {
        this.$router.push({ name: 'frevi-movements', params: { serialNumber: this.appliance.serialNumber }});
      },
      closeAnomaly() {
        this.applianceService.patchHideAnomalies(this.personaltoken, this.serialNumber)
          .then((data) => {
            if(data.code=="200") {
              // Tutto ok
              this.reloadAppliance();
            } else {
              console.error(JSON.stringify(data));
              this.dialog.error = true;
              setTimeout(function() {
                this.reloadAppliance();
              }.bind(this),3000);
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
            setTimeout(function() {
                this.reloadAppliance();
              }.bind(this),3000);
          });
      },
      hasPlanActive(planCode) {
        return this.appliance?.plans?.some(plan => plan.code === planCode && plan.startDate !=null);
      },
      hasPlanActivable(planCode) {
        return this.appliance?.plans?.some(plan => plan.code === planCode && plan.startDate == null);
      },
      closePlusPremium() {
        console.log("closePlusPremium");
        this.infoBox.closePlusPremiumAdvise = true;
        sessionStorage.setItem(this.serialNumber+'_closePlusPremiumAdvise', 'true');
      }
    }
}
</script>

<style >

</style>